import {
  DemoCaseResponseSchema,
  HttpPaths,
  httpRouteContracts,
  parseContract,
} from "@rnavoyager/contracts";
import type { DemoCaseResponse, ContinueDemoBody } from "@rnavoyager/contracts";
import type { Static } from "@sinclair/typebox";
const continuationSchema = httpRouteContracts.continueDemo.response[200];
export type DemoContinuation = Static<typeof continuationSchema>;

async function json(response: Response): Promise<unknown> {
  let value: unknown;
  try {
    value = await response.json();
  } catch {
    throw new Error("研究案例暂时不可用，请稍后再试。");
  }
  if (!response.ok) {
    if (response.status === 401)
      window.dispatchEvent(
        new CustomEvent("rnavoyager:auth-expired", { detail: "登录已过期，请重新登录。" }),
      );
    const message =
      typeof value === "object" &&
      value !== null &&
      "message" in value &&
      typeof value.message === "string"
        ? value.message
        : "研究案例暂时无法读取";
    throw new Error(message);
  }
  return value;
}
export async function readDemoCase(
  caseId: string,
  signal?: AbortSignal,
): Promise<DemoCaseResponse> {
  return parseContract(
    DemoCaseResponseSchema,
    await json(
      await fetch(HttpPaths.demoCase.replace(":caseId", encodeURIComponent(caseId)), {
        signal,
        credentials: "same-origin",
      }),
    ),
  );
}
export async function continueDemo(
  caseId: string,
  body: ContinueDemoBody,
): Promise<DemoContinuation> {
  return parseContract(
    continuationSchema,
    await json(
      await fetch(HttpPaths.continueDemo.replace(":caseId", encodeURIComponent(caseId)), {
        method: "POST",
        credentials: "same-origin",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(body),
      }),
    ),
  );
}
export function demoAssetUrl(
  caseId: string,
  assetId: string,
  caseDigest: string,
  download = false,
): string {
  return (
    HttpPaths.demoAsset
      .replace(":caseId", encodeURIComponent(caseId))
      .replace(":assetId", encodeURIComponent(assetId)) +
    `?caseDigest=${encodeURIComponent(caseDigest)}${download ? "&download=1" : ""}`
  );
}
